var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDrageVideo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12271_121452)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5403 6.52156C22.4215 6.04697 22.1796 5.61213 21.839 5.26097C21.4984 4.9098 21.0711 4.65475 20.6003 4.52156C18.8803 4.10156 12.0003 4.10156 12.0003 4.10156C12.0003 4.10156 5.12033 4.10156 3.40033 4.56156C2.92957 4.69475 2.5023 4.9498 2.16167 5.30097C1.82104 5.65213 1.57912 6.08697 1.46033 6.56156C1.14554 8.30712 0.991563 10.0779 1.00033 11.8516C0.989107 13.6386 1.1431 15.4229 1.46033 17.1816C1.59129 17.6414 1.83863 18.0597 2.17847 18.396C2.51831 18.7324 2.93915 18.9754 3.40033 19.1016C5.12033 19.5616 12.0003 19.5616 12.0003 19.5616C12.0003 19.5616 18.8803 19.5616 20.6003 19.1016C21.0711 18.9684 21.4984 18.7133 21.839 18.3622C22.1796 18.011 22.4215 17.5762 22.5403 17.1016C22.8527 15.3692 23.0067 13.6119 23.0003 11.8516C23.0115 10.0645 22.8576 8.28026 22.5403 6.52156Z",
    stroke: "#4A4540",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75024 15.122L15.5002 11.852L9.75024 8.58203V15.122Z",
    stroke: "#4A4540",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12271_121452"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.000244141 0.101562)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrageVideo);
export default __webpack_public_path__ + "static/media/drageVideo.acc64b3334dcb44bf1ec6b41daa48e0a.svg";
export { ForwardRef as ReactComponent };